"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.assemble = exports.setBreakpointAtLine = exports.createContext = exports.compile = exports.interrupt = exports.resume = exports.runInContext = exports.getTypeInformation = exports.getNames = exports.hasDeclaration = exports.getAllOccurrencesInScope = exports.getScope = exports.findDeclaration = exports.parseError = exports.SourceDocumentation = void 0;
const walkers_1 = require("./utils/walkers");
const source_map_1 = require("source-map");
const constants_1 = require("./constants");
const createContext_1 = require("./createContext");
exports.createContext = createContext_1.default;
const errors_1 = require("./errors/errors");
const runtimeSourceError_1 = require("./errors/runtimeSourceError");
const finder_1 = require("./finder");
const interpreter_1 = require("./interpreter/interpreter");
const parser_1 = require("./parser/parser");
const schedulers_1 = require("./schedulers");
const scope_refactoring_1 = require("./scope-refactoring");
const inspector_1 = require("./stdlib/inspector");
Object.defineProperty(exports, "setBreakpointAtLine", { enumerable: true, get: function () { return inspector_1.setBreakpointAtLine; } });
const stepper_1 = require("./stepper/stepper");
const evalContainer_1 = require("./transpiler/evalContainer");
const transpiler_1 = require("./transpiler/transpiler");
const gpu_1 = require("./gpu/gpu");
const lazy_1 = require("./lazy/lazy");
const interpreter_non_det_1 = require("./interpreter/interpreter-non-det");
const astCreator_1 = require("./utils/astCreator");
const validator_1 = require("./validator/validator");
const svml_compiler_1 = require("./vm/svml-compiler");
const svml_assembler_1 = require("./vm/svml-assembler");
Object.defineProperty(exports, "assemble", { enumerable: true, get: function () { return svml_assembler_1.assemble; } });
const svml_machine_1 = require("./vm/svml-machine");
var docTooltip_1 = require("./editors/ace/docTooltip");
Object.defineProperty(exports, "SourceDocumentation", { enumerable: true, get: function () { return docTooltip_1.SourceDocumentation; } });
const name_extractor_1 = require("./name-extractor");
const typeChecker_1 = require("./typeChecker/typeChecker");
const stringify_1 = require("./utils/stringify");
const operators_1 = require("./utils/operators");
const InfiniteLoops_1 = require("./infiniteLoops/InfiniteLoops");
const timeoutErrors_1 = require("./errors/timeoutErrors");
const DEFAULT_OPTIONS = {
    scheduler: 'async',
    steps: 1000,
    stepLimit: 1000,
    executionMethod: 'auto',
    variant: 'default',
    originalMaxExecTime: 1000,
    useSubst: false,
    isPrelude: false
};
// needed to work on browsers
if (typeof window !== 'undefined') {
    // @ts-ignore
    source_map_1.SourceMapConsumer.initialize({
        'lib/mappings.wasm': 'https://unpkg.com/source-map@0.7.3/lib/mappings.wasm'
    });
}
// deals with parsing error objects and converting them to strings (for repl at least)
let verboseErrors = false;
const resolvedErrorPromise = Promise.resolve({ status: 'error' });
function parseError(errors, verbose = verboseErrors) {
    const errorMessagesArr = errors.map(error => {
        const line = error.location ? error.location.start.line : '<unknown>';
        const column = error.location ? error.location.start.column : '<unknown>';
        const explanation = error.explain();
        if (verbose) {
            // TODO currently elaboration is just tagged on to a new line after the error message itself. find a better
            // way to display it.
            const elaboration = error.elaborate();
            return `Line ${line}, Column ${column}: ${explanation}\n${elaboration}\n`;
        }
        else {
            return `Line ${line}: ${explanation}`;
        }
    });
    return errorMessagesArr.join('\n');
}
exports.parseError = parseError;
function convertNativeErrorToSourceError(error, line, column, name) {
    // brute-forced from MDN website for phrasing of errors from different browsers
    // FWIW node and chrome uses V8 so they'll have the same error messages
    // unable to test on other engines
    const assignmentToConst = [
        'invalid assignment to const',
        'Assignment to constant variable',
        'Assignment to const',
        'Redeclaration of const'
    ];
    const undefinedVariable = ['is not defined'];
    const message = error.message;
    if (name === null) {
        name = 'UNKNOWN';
    }
    function messageContains(possibleErrorMessages) {
        return possibleErrorMessages.some(errorMessage => message.includes(errorMessage));
    }
    if (messageContains(assignmentToConst)) {
        return new errors_1.ConstAssignment(astCreator_1.locationDummyNode(line, column), name);
    }
    else if (messageContains(undefinedVariable)) {
        return new errors_1.UndefinedVariable(name, astCreator_1.locationDummyNode(line, column));
    }
    else {
        const location = line === null || column === null
            ? constants_1.UNKNOWN_LOCATION
            : {
                start: { line, column },
                end: { line: -1, column: -1 }
            };
        return new errors_1.ExceptionError(error, location);
    }
}
let previousCode = '';
let isPreviousCodeTimeoutError = false;
function determineExecutionMethod(theOptions, context, program) {
    let isNativeRunnable;
    if (theOptions.executionMethod === 'auto') {
        if (context.executionMethod === 'auto') {
            if (verboseErrors) {
                isNativeRunnable = false;
            }
            else if (inspector_1.areBreakpointsSet()) {
                isNativeRunnable = false;
            }
            else {
                let hasDeuggerStatement = false;
                walkers_1.simple(program, {
                    DebuggerStatement(node) {
                        hasDeuggerStatement = true;
                    }
                });
                isNativeRunnable = !hasDeuggerStatement;
            }
            context.executionMethod = isNativeRunnable ? 'native' : 'interpreter';
        }
        else {
            isNativeRunnable = context.executionMethod === 'native';
        }
    }
    else {
        isNativeRunnable = theOptions.executionMethod === 'native';
        context.executionMethod = theOptions.executionMethod;
    }
    return isNativeRunnable;
}
function findDeclaration(code, context, loc) {
    const program = parser_1.parse(code, context, true);
    if (!program) {
        return null;
    }
    const identifierNode = finder_1.findIdentifierNode(program, context, loc);
    if (!identifierNode) {
        return null;
    }
    const declarationNode = finder_1.findDeclarationNode(program, identifierNode);
    if (!declarationNode || identifierNode === declarationNode) {
        return null;
    }
    return declarationNode.loc;
}
exports.findDeclaration = findDeclaration;
function getScope(code, context, loc) {
    const program = parser_1.parse(code, context, true);
    if (!program) {
        return [];
    }
    const identifierNode = finder_1.findIdentifierNode(program, context, loc);
    if (!identifierNode) {
        return [];
    }
    const declarationNode = finder_1.findDeclarationNode(program, identifierNode);
    if (!declarationNode || declarationNode.loc == null || identifierNode !== declarationNode) {
        return [];
    }
    return scope_refactoring_1.getScopeHelper(declarationNode.loc, program, identifierNode.name);
}
exports.getScope = getScope;
function getAllOccurrencesInScope(code, context, loc) {
    const program = parser_1.parse(code, context, true);
    if (!program) {
        return [];
    }
    const identifierNode = finder_1.findIdentifierNode(program, context, loc);
    if (!identifierNode) {
        return [];
    }
    const declarationNode = finder_1.findDeclarationNode(program, identifierNode);
    if (declarationNode == null || declarationNode.loc == null) {
        return [];
    }
    return scope_refactoring_1.getAllOccurrencesInScopeHelper(declarationNode.loc, program, identifierNode.name);
}
exports.getAllOccurrencesInScope = getAllOccurrencesInScope;
function hasDeclaration(code, context, loc) {
    const program = parser_1.parse(code, context, true);
    if (!program) {
        return false;
    }
    const identifierNode = finder_1.findIdentifierNode(program, context, loc);
    if (!identifierNode) {
        return false;
    }
    const declarationNode = finder_1.findDeclarationNode(program, identifierNode);
    if (declarationNode == null || declarationNode.loc == null) {
        return false;
    }
    return true;
}
exports.hasDeclaration = hasDeclaration;
function getNames(code, line, col, context) {
    return __awaiter(this, void 0, void 0, function* () {
        const [program, comments] = parser_1.parseForNames(code);
        if (!program) {
            return [];
        }
        const cursorLoc = { line, column: col };
        const [progNames, displaySuggestions] = name_extractor_1.getProgramNames(program, comments, cursorLoc);
        const keywords = name_extractor_1.getKeywords(program, cursorLoc, context);
        return [progNames.concat(keywords), displaySuggestions];
    });
}
exports.getNames = getNames;
function typedParse(code, context) {
    const program = parser_1.parse(code, context, true);
    if (program === undefined) {
        return null;
    }
    return validator_1.validateAndAnnotate(program, context);
}
function getTypeInformation(code, context, loc, name) {
    try {
        // parse the program into typed nodes and parse error
        const program = typedParse(code, context);
        if (program === null) {
            return '';
        }
        if (context.prelude !== null) {
            typeChecker_1.typeCheck(typedParse(context.prelude, context), context);
        }
        const [typedProgram, error] = typeChecker_1.typeCheck(program, context);
        const parsedError = parseError(error);
        if (context.prelude !== null) {
            // the env of the prelude was added, we now need to remove it
            context.typeEnvironment.pop();
        }
        // initialize the ans string
        let ans = '';
        if (parsedError) {
            ans += parsedError + '\n';
        }
        if (!typedProgram) {
            return ans;
        }
        // get name of the node
        const getName = (typedNode) => {
            var _a;
            let nodeId = '';
            if (typedNode.type) {
                if (typedNode.type === 'FunctionDeclaration') {
                    nodeId = (_a = typedNode.id) === null || _a === void 0 ? void 0 : _a.name;
                }
                else if (typedNode.type === 'VariableDeclaration') {
                    nodeId = typedNode.declarations[0].id.name;
                }
                else if (typedNode.type === 'Identifier') {
                    nodeId = typedNode.name;
                }
            }
            return nodeId;
        };
        // callback function for findNodeAt function
        function findByLocationPredicate(t, nd) {
            if (!nd.inferredType) {
                return false;
            }
            const isInLoc = (nodeLoc) => {
                return !(nodeLoc.start.line > loc.line ||
                    nodeLoc.end.line < loc.line ||
                    (nodeLoc.start.line === loc.line && nodeLoc.start.column > loc.column) ||
                    (nodeLoc.end.line === loc.line && nodeLoc.end.column < loc.column));
            };
            const location = nd.loc;
            if (nd.type && location) {
                return getName(nd) === name && isInLoc(location);
            }
            return false;
        }
        // report both as the type inference
        const res = walkers_1.findNodeAt(typedProgram, undefined, undefined, findByLocationPredicate);
        if (res === undefined) {
            return ans;
        }
        const node = res.node;
        if (node === undefined) {
            return ans;
        }
        const actualNode = node.type === 'VariableDeclaration'
            ? node.declarations[0].init
            : node;
        const type = stringify_1.typeToString(actualNode.type === 'FunctionDeclaration'
            ? actualNode.functionInferredType
            : actualNode.inferredType);
        return ans + `At Line ${loc.line} => ${getName(node)}: ${type}`;
    }
    catch (error) {
        return '';
    }
}
exports.getTypeInformation = getTypeInformation;
function runInContext(code, context, options = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        function getFirstLine(theCode) {
            const theProgramFirstExpression = parser_1.parseAt(theCode, 0);
            if (theProgramFirstExpression && theProgramFirstExpression.type === 'Literal') {
                return theProgramFirstExpression.value;
            }
            return undefined;
        }
        const theOptions = Object.assign(Object.assign({}, DEFAULT_OPTIONS), options);
        context.variant = determineVariant(context, options);
        context.errors = [];
        verboseErrors = getFirstLine(code) === 'enable verbose';
        const program = parser_1.parse(code, context);
        if (!program) {
            return resolvedErrorPromise;
        }
        validator_1.validateAndAnnotate(program, context);
        typeChecker_1.typeCheck(program, context);
        if (context.errors.length > 0) {
            return resolvedErrorPromise;
        }
        if (context.variant === 'concurrent') {
            if (previousCode === code) {
                context.nativeStorage.maxExecTime *= constants_1.JSSLANG_PROPERTIES.factorToIncreaseBy;
            }
            else {
                context.nativeStorage.maxExecTime = theOptions.originalMaxExecTime;
            }
            previousCode = code;
            try {
                return Promise.resolve({
                    status: 'finished',
                    value: svml_machine_1.runWithProgram(svml_compiler_1.compileForConcurrent(program, context), context)
                });
            }
            catch (error) {
                if (error instanceof runtimeSourceError_1.RuntimeSourceError || error instanceof errors_1.ExceptionError) {
                    context.errors.push(error); // use ExceptionErrors for non Source Errors
                    return resolvedErrorPromise;
                }
                context.errors.push(new errors_1.ExceptionError(error, constants_1.UNKNOWN_LOCATION));
                return resolvedErrorPromise;
            }
        }
        if (options.useSubst) {
            const steps = stepper_1.getEvaluationSteps(program, context, options.stepLimit);
            const redexedSteps = [];
            for (const step of steps) {
                const redexed = stepper_1.redexify(step[0], step[1]);
                redexedSteps.push({
                    code: redexed[0],
                    redex: redexed[1],
                    explanation: step[2]
                });
            }
            return Promise.resolve({
                status: 'finished',
                value: redexedSteps
            });
        }
        if (context.chapter <= 2) {
            InfiniteLoops_1.addInfiniteLoopProtection(program, context.chapter === 2);
        }
        const isNativeRunnable = determineExecutionMethod(theOptions, context, program);
        if (context.prelude !== null) {
            const prelude = context.prelude;
            context.prelude = null;
            yield runInContext(prelude, context, Object.assign(Object.assign({}, options), { isPrelude: true }));
            return runInContext(code, context, options);
        }
        if (isNativeRunnable) {
            if (previousCode === code && isPreviousCodeTimeoutError) {
                context.nativeStorage.maxExecTime *= constants_1.JSSLANG_PROPERTIES.factorToIncreaseBy;
            }
            else if (!options.isPrelude) {
                context.nativeStorage.maxExecTime = theOptions.originalMaxExecTime;
            }
            if (!options.isPrelude) {
                previousCode = code;
            }
            let transpiled;
            let sourceMapJson;
            let lastStatementSourceMapJson;
            try {
                // Mutates program
                switch (context.variant) {
                    case 'gpu':
                        gpu_1.transpileToGPU(program);
                        break;
                    case 'lazy':
                        lazy_1.transpileToLazy(program);
                        break;
                }
                const temp = transpiler_1.transpile(program, context, false);
                // some issues with formatting and semicolons and tslint so no destructure
                transpiled = temp.transpiled;
                sourceMapJson = temp.codeMap;
                lastStatementSourceMapJson = temp.evalMap;
                let value = evalContainer_1.sandboxedEval(transpiled, context.nativeStorage, context.moduleParams);
                if (context.variant === 'lazy') {
                    value = operators_1.forceIt(value);
                }
                if (!options.isPrelude) {
                    isPreviousCodeTimeoutError = false;
                }
                return Promise.resolve({
                    status: 'finished',
                    value
                });
            }
            catch (error) {
                if (error instanceof runtimeSourceError_1.RuntimeSourceError) {
                    context.errors.push(error);
                    if (error instanceof timeoutErrors_1.TimeoutError) {
                        isPreviousCodeTimeoutError = true;
                    }
                    return resolvedErrorPromise;
                }
                if (error instanceof errors_1.ExceptionError) {
                    // if we know the location of the error, just throw it
                    if (error.location.start.line !== -1) {
                        context.errors.push(error);
                        return resolvedErrorPromise;
                    }
                    else {
                        error = error.error; // else we try to get the location from source map
                    }
                }
                const errorStack = error.stack;
                const match = /<anonymous>:(\d+):(\d+)/.exec(errorStack);
                if (match === null) {
                    context.errors.push(new errors_1.ExceptionError(error, constants_1.UNKNOWN_LOCATION));
                    return resolvedErrorPromise;
                }
                const line = Number(match[1]);
                const column = Number(match[2]);
                return source_map_1.SourceMapConsumer.with(line === 1 ? lastStatementSourceMapJson : sourceMapJson, null, consumer => {
                    const { line: originalLine, column: originalColumn, name } = consumer.originalPositionFor({
                        line,
                        column
                    });
                    context.errors.push(convertNativeErrorToSourceError(error, originalLine, originalColumn, name));
                    return resolvedErrorPromise;
                });
            }
        }
        else {
            let it = interpreter_1.evaluate(program, context);
            let scheduler;
            if (context.variant === 'non-det') {
                it = interpreter_non_det_1.nonDetEvaluate(program, context);
                scheduler = new schedulers_1.NonDetScheduler();
            }
            else if (theOptions.scheduler === 'async') {
                scheduler = new schedulers_1.AsyncScheduler();
            }
            else {
                scheduler = new schedulers_1.PreemptiveScheduler(theOptions.steps);
            }
            return scheduler.run(it, context);
        }
    });
}
exports.runInContext = runInContext;
/**
 * Small function to determine the variant to be used
 * by a program, as both context and options can have
 * a variant. The variant provided in options will
 * have precedence over the variant provided in context.
 *
 * @param context The context of the program.
 * @param options Options to be used when
 *                running the program.
 *
 * @returns The variant that the program is to be run in
 */
function determineVariant(context, options) {
    if (options.variant) {
        return options.variant;
    }
    else {
        return context.variant;
    }
}
function resume(result) {
    if (result.status === 'finished' || result.status === 'error') {
        return result;
    }
    else {
        return result.scheduler.run(result.it, result.context);
    }
}
exports.resume = resume;
function interrupt(context) {
    const globalEnvironment = context.runtime.environments[context.runtime.environments.length - 1];
    context.runtime.environments = [globalEnvironment];
    context.runtime.isRunning = false;
    context.errors.push(new errors_1.InterruptedError(context.runtime.nodes[0]));
}
exports.interrupt = interrupt;
function compile(code, context, vmInternalFunctions) {
    const astProgram = parser_1.parse(code, context);
    if (!astProgram) {
        return undefined;
    }
    try {
        return svml_compiler_1.compileToIns(astProgram, undefined, vmInternalFunctions);
    }
    catch (error) {
        context.errors.push(error);
        return undefined;
    }
}
exports.compile = compile;
//# sourceMappingURL=index.js.map